import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {ResolvedVisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/ResolvedVisualComponent';
import {VisualArtifactRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualArtifactRef';
import {
    LocalComponentDef,
    VisualComponent,
    VisualComponentId
} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';
import {LocalVisualComponentRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponentRef';
import {BoxTypes, IBoxSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {Viewport} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/Viewport';
import {IPageSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {ISurfaceStateSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/SurfaceState';

export enum ViewportTypes
{
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
}

const MOBILE_TABLET:number = 768;
const TABLET_DESKTOP:number = 1024;

export class ViewportUtil
{
    private static viewportDef:LocalComponentDef = new LocalComponentDef(
        require('@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/Viewport'),
        '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/Viewport',
        'Viewport'
    );

    private static viewportVisualArtifactRef:VisualArtifactRef = new VisualArtifactRef(
        'mintdata', 'mint-bdp', '0.0.0'
    );

    public static addViewportToVisualComponents():VisualComponent
    {
        const componentId = this.getViewportComponentId();
        const visualComponents:Map<VisualComponentId, VisualComponent> = commonControllers.artifacts.getVisualComponents();

        if( visualComponents.has(componentId) )
            return;

        const aModule = this.viewportDef.aModule;//require(def.getRequirePath());
        const aCtor = aModule[this.viewportDef.exportName];
        const componentName = this.viewportDef.exportName;
        const desc = '';
        const rvc = new ResolvedVisualComponent(aCtor);
        const vcRef = new LocalVisualComponentRef(
            componentId,
            '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/Viewport',
            this.viewportDef.exportName,
            rvc
        );

        const viewportVC:VisualComponent = new VisualComponent(this.viewportVisualArtifactRef, vcRef, componentName, desc);
        visualComponents.set(componentId, viewportVC);

        return viewportVC;
    }

    public static getViewportVisualComponent():VisualComponent
    {
        ViewportUtil.addViewportToVisualComponents();
        const componentId = this.getViewportComponentId();
        const visualComponents:Map<VisualComponentId, VisualComponent> = commonControllers.artifacts.getVisualComponents();

        return visualComponents.get(componentId);
    }

    public static getViewportComponentId():string
    {
        return VisualComponent.idFrom(this.viewportVisualArtifactRef, this.viewportDef.exportName);
    }

    public static getViewportTypeByWidth(width:number):ViewportTypes
    {
        if( width < MOBILE_TABLET )
            return ViewportTypes.Mobile;

        if( width < TABLET_DESKTOP )
            return ViewportTypes.Tablet;

        return ViewportTypes.Desktop;
    }

    public static validateViewportSettings(surfaceSnapshot:ISurfaceStateSnapshot):void
    {
        Object.values(surfaceSnapshot.pages).forEach((pageSnapshot:IPageSnapshot) =>
        {
            const viewport:IBoxSnapshot = Object.values(pageSnapshot.artboard.allBoxes).find(
                (boxSnapshot:IBoxSnapshot) => boxSnapshot.boxType === BoxTypes.Viewport
            );

            if( viewport )
            {
                viewport.parent = null;

                if( !pageSnapshot.artboard.boxes.includes(viewport.id) )
                    pageSnapshot.artboard.boxes.push(viewport.id);
            }
        });
    }
}
